import Additional from "@core/Additional.js";
import Constant from "@constant/index.js";
import Sku from "@core/Sku.js";
import {$array, $event_publisher} from "@util/util.js";
import ActionTool from "@core/ActionTool.js";

export default class ServicesAdditional extends Additional{
    constructor(){
        super();
        this._additionalType = Constant.ADDITIONAL_TYPE.SERVICE;
    }

    removeServiceItemById(id){
        this._items = $array.removeItem(this._items, {_id:id});
    }

    removeServices(sid){
        return new Promise((reslove,reject)=>{
            ActionTool.removeAction({model:this._parent, servicesId:sid}).then(data=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                $event_publisher.broadcast(Constant.EVENT_KEY.CHANGE_ALL_ACTIVE, data);
                //通知model，里面有servicesItem被删除
                $event_publisher.broadcast(Constant.EVENT_KEY.REMOVE_SERVICE, {model:this, id:sid});
                reslove();
            }).catch(err=>{
                reject(err.msg);
            })
        });
    }

    init(data){
        this._data = data;
        this._data.forEach(x => {
            let _sku = new Sku();
            _sku.init(x, this);
            this.addItem(_sku);
        });
    }
}